__turbopack_context__.v({
  "border1": "button-module-scss-module__WaAcsW__border1",
  "border2": "button-module-scss-module__WaAcsW__border2",
  "button": "button-module-scss-module__WaAcsW__button",
  "button1": "button-module-scss-module__WaAcsW__button1",
  "designBlendingMode": "button-module-scss-module__WaAcsW__designBlendingMode",
  "designBlendingMode1": "button-module-scss-module__WaAcsW__designBlendingMode1",
  "focusRing": "button-module-scss-module__WaAcsW__focusRing",
});
